// extracted by mini-css-extract-plugin
export var productImage = "_r0-1";
export var viewLink = "_r0-2";
export var wishlistItem = "_r0-0";